import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '@leandredev/common_ng_14';
import { IAct } from '@leandredev/dcbm-common-lib/dist/interfaces';
import { debounceTime, filter, map, switchMap } from 'rxjs';
import { ActsService } from 'src/app/services/acts/acts.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent extends BaseComponent {
  private typesAndClasse = [
    { type: environment.data.defaultTypes.physicalPerson, class: 'NaturalPerson' },
    { type: environment.data.defaultTypes.physicalEntity, class: 'PhysicalEntity' },
    { type: environment.data.defaultTypes.moralPerson, class: 'MoralPerson' },
    { type: environment.data.defaultTypes.folder, class: 'Act' }
  ];

  private editActUrl: { class: string; id: string } = null;

  public selectTypes: string[] = [];

  public control = new FormControl<string | IAct>(null);
  public options: string[] = [];
  public data: IAct[];

  constructor(private router: Router, private activeRoute: ActivatedRoute, private actsService: ActsService) {
    super();
    this.selectTypes = this.typesAndClasse.map((t) => t.type.id);

    this.control.valueChanges
      .pipe(
        filter((value) => typeof value == 'string'),
        debounceTime(200),
        switchMap((value: string) => {
          return this.actsService.getData(value, this.selectTypes).pipe(
            map((data) => {
              if (data) this.data = data;
            })
          );
        })
      )
      .subscribe();
  }

  public open(): void {
    if (typeof this.control.valid != 'string') {
      const act: IAct = this.control.value as IAct;

      const typeAndClass = this.typesAndClasse.find((t) => t.type.id === act.templateReference_pop.defaultType);

      this.editActUrl = { class: typeAndClass.class, id: act._id.toString() };

      void this.router.navigate([`data/${this.editActUrl.class}/edit/${this.editActUrl.id}`], { relativeTo: this.activeRoute.parent });

      this.control.reset();
    }
  }
}
